import { useCallback, useState, useEffect } from 'react'
import CustomTableItemLoader from 'components/CustomTableItemLoader'
import CustomTable from 'components/table/CustomTable'
import { cloneDeep } from 'lodash'
import { TableRow } from 'components/table/CustomTable'
import { TableHeader } from 'components/table/CustomTable'
import { useSelector } from 'react-redux'
import { BannerColumnItems } from './constants'
import BannerItem from './BannerItem'
import ConfirmModal from 'components/ConfirmModal'
import { useDispatch } from 'react-redux'
import { removeBanner } from 'redux/slices/bannerSlices'
import { rearrangeBanners } from 'redux/slices/bannerSlices'
import CustomIcon from 'components/CustomIcon'
import CustomButton from 'components/CustomButton'
import CardFooter from 'components/card/CardFooter'

const BannerItemCard = ({ setImageToBePreviewed, setUpdateBanner, retry }) => {
  const {
    pages: { data: pageData, selectedPage },
    banners: { loading, error, activeTab, allBanners, processing, hasNext, hasPrev , init},
  } = useSelector((state) => state.banner)

  const [cards, setCards] = useState([])
  const [showConfirmModal, setShowConfirmModal] = useState()
  const dispatch = useDispatch()

  useEffect(() => {
    setCards(allBanners)
    setShowConfirmModal()
  }, [allBanners])

  const findCard = useCallback(
    (id) => {
      const card = cards.filter((c) => c.id === id)[0]
      return {
        card,
        index: cards.indexOf(card),
      }
    },
    [cards],
  )

  const moveCard = useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id)
      const tempArray = cloneDeep(cards)
      tempArray.splice(index, 1)
      tempArray.splice(atIndex, 0, card)

      setCards(tempArray)
    },
    [findCard, cards, setCards],
  )

  const modifyPriority = (sourceItem, targetItem) => {
    let payload = {}
    if (sourceItem.active_banner.priority < targetItem.active_banner.priority) {
      // increment priority of targetItem by 1
      payload = {
        priority: targetItem.active_banner.priority + 1,
      }
    } else {
      payload = {
        priority: targetItem.active_banner.priority,
      }
    }
    dispatch(
      rearrangeBanners({
        activeBannerId: sourceItem.active_banner.id,
        payload,
      }),
    )
  }

  const removeBannerAction = () => {
    dispatch(
      removeBanner({
        bannerId: showConfirmModal.selectedBannerId,
      }),
    )
  }

  return (
    <div>
      <CustomTable>
        <thead>
          <TableRow>
            {BannerColumnItems.map((i, index) => (
              <TableHeader key={`${i}-${index}`}>{i}</TableHeader>
            ))}
          </TableRow>
        </thead>
        {loading || error.length > 0 || cards.length === 0 ? (
          <CustomTableItemLoader
            colSpan={4}
            loading={loading || !init}
            error={error}
            isEmpty={cards.length === 0}
            retry={() => {
              retry(true)
            }}
          />
        ) : (
          <tbody>
            {cards.map((card, i) => (
              <BannerItem
                key={card.id}
                id={card.id}
                bannerItem={card}
                moveCard={moveCard}
                findCard={findCard}
                screen={pageData.find((p) => p.id === selectedPage)}
                tab={activeTab}
                onDelete={() => {
                  setShowConfirmModal({
                    selectedBannerId: card.id,
                  })
                }}
                onDraggedAndDropped={({ sourceItem, targetIndex }) => {
                  const targetItem = allBanners[targetIndex]
                  modifyPriority(sourceItem, targetItem)
                }}
                onImageClicked={(image) => {
                  setImageToBePreviewed({ image })
                }}
                onUpdateBanner={() => {
                  setUpdateBanner({ data: cards[i] })
                }}
              />
            ))}
          </tbody>
        )}
      </CustomTable>
      {!(loading || error.length > 0 || !init) && (
        <CardFooter>
          <div className="flex justify-end space-x-4">
            <CustomButton
              className="rounded"
              onClick={() => retry(true,true)}
              disabled={!hasPrev}
            >
              <CustomIcon className="w-4 mt-1" icon="keyboard_arrow_left" />
            </CustomButton>

            <CustomButton
              className="rounded"
              onClick={() => retry(true)}
              disabled={!hasNext}
            >
              <CustomIcon className="w-4 mt-1" icon="keyboard_arrow_right" />
            </CustomButton>
          </div>
        </CardFooter>
      )}
      <ConfirmModal
        children="This will remove banner. Are you sure?"
        disabled={false}
        showModal={!!showConfirmModal}
        setShowModal={() => setShowConfirmModal()}
        onConfirm={removeBannerAction}
        loading={processing}
      />
    </div>
  )
}

export default BannerItemCard
